import React,
       { useContext } from 'react';
import { Stack } from '../util/util';
import { TIMES,
         INFO,
         CONSTS,
         RUNS,
         HISTORY, 
         CONSLOG,
         initCONSLOG,
         storeConsoleLog} from '../util/object';
import { BUCKET_API_SERVER, NODE_API_SERVER } from '../util/constants'
import { mergeSTATSSummary, 
         isolatePerfSummary,
         } from '../util/performance';
import { VIMEO_BEARER_TOKEN,
         IPAPI_TOKEN,
         GOOGLE_BUCKET_SERVER,
         } from '../util/constants';
import { arrayTimestampAscSort, 
         arrayTimestampDesSort, 
         arrayTimelineAscSort,
         arraySeqAscSort,
         tidyNumber,
         NOW,
         } from '../util/util';
import { bucket_store_string,
         bucket_store_blob,
         } from '../util/firebaseClient';
import { CorsUploader } from '../util/corsUploader';
import { AuthClass } from '../class/AuthClass';
import { process_user_invite } from "../util/util";

const tus = require('tus-js-client');
var auth = new AuthClass();


/////////////////////////////////////////////////////////////////////////
// CLIENT-SIDE:  VIMEO video upload
//
// Token: need upload, edit scope
// src: https://developer.vimeo.com/api/upload/videos


// start vimeo video streaming (still need to figure out termination  4/2021)
//    - on start it setups vimeo video container and keeps url in INFO.tus_url
//    - on stop it closes connection
//
export async function recordVimeoStream(file_name, start) {
    var vimeo_url = "https://api.vimeo.com/me/videos";
    var file_url, body = {};

    const MAX_BYTES = 300000;
    if(start === true) {
        body.upload = {}
        body.upload.approach= "tus";
        body.upload.size= MAX_BYTES;
        body.name = file_name;      // the video title

        var res = await postVimeoURL(vimeo_url, body);    // first create a handle on vimeo
        file_url = res.upload.upload_link;
        INFO.tus_url = file_url;
        console.log("vupload.37: START UPLOAD res.upload url=", file_url);

        console.log("vupload.50:      USER=",res.user.uri);
        console.log("vupload.51:      UPLOAD_ID=",res.upload.upload_link);

        startTusStreamUpload(file_url, 300000, 100000);
    } else {
        if (stopTusRecording !== null){

            // to complete a streaming upload
            // src: https://developer.vimeo.com/api/reference/videos#complete_streaming_upload
            //DELETE  https://api.vimeo.com/users/{user_id}/uploads/{upload_id}

            var res = patchVimeoURL(INFO.tus_url, {}, MAX_BYTES);
            console.log("vupload.56:  STOP STREAM UPLOAD   res=",res);

            var USER_ID = 138055078;     // user.uri: "/users/138055078"
            var UPLOAD_ID = 138055078;   // "https://us-files.tus.vimeo.com/files/vimeo-prod-src-tus-us/54d9c7d935ff04bf6d444c6b7533a8be"

            stopTusRecording();
        }
    }

}


// store a completed video file to vimeo
//
export async function storeVimeoFile(file_name, src_file) {
    var vimeo_url = "https://api.vimeo.com/me/videos";
    var file_url, file_size, body = {};
    //var src_type = typeof(src_file);
    var src_type = src_file.constructor.name;

    console.log("vfileload.94:   # # # # # # # # # #  START STORE VIMEO FILE   file_name=", file_name, " src_file=", src_file);
    switch(src_type) {
        case "Blob":
            file_size = src_file.size;
            console.log("uploadVimeo.84:          . . . .  BLOB type=", src_type, " file=", src_file, " size=", file_size);
            break;
        default:
            console.error("uploadVimeo.88:          ! ! ! !  UNSUPPORTED type=", src_type, " file=", src_file, " size=", file_size);
            return;
    }

    body.upload = {}
    body.upload.approach= "tus";
    body.upload.size= file_size;
    body.name = file_name;      // the video title
    //body.privacy = { "view": "nobody" }

    var res = await postVimeoURL(vimeo_url, body);    // first create a handle on vimeo
    file_url = res.upload.upload_link;
    INFO.tus_url = file_url;
    console.log("vfileload.99:      . . . START FILE UPLOAD res.upload url=", file_url, " link=",res.link, " src_file=",src_file);
    startTusUpload(src_file, src_file.size, file_url, 10000000);   // need to CONSTS chunk size

    INFO.vimeo_link = res.link;

    return res.link;
}


const VIMEO_SESSION_FOLDER_ID = 4296319;

// after file is updloaded, set the thumbnail
//
// ref: https://developer.vimeo.com/api/reference/videos/3.4#edit_video_thumbnail
//
export async function updateVimeoThumbnail(res_link) {
    if (!res_link) { return };

    var bits = res_link.split("/");
    var video_id = bits.pop();
    var thumbnail_url = "https://api.vimeo.com/videos/"+video_id+"/pictures"
    var body = {};
    body.time = 18;      // random frame in seconds
    body.active = true;
    var res1 = await postVimeoURL(thumbnail_url, body);    // first create a handle on vimeo
    console.log("vfileload.129:     . . . UPDATE VIDEO THUMBNAIL  url=", thumbnail_url, " body=",body, " res1=",res1);

    var folder_url = "https://api.vimeo.com/me/projects/"+VIMEO_SESSION_FOLDER_ID+"/videos/"+video_id;
    var res2 = await putVimeoURL(folder_url);    // first create a handle on vimeo
    //move to folder: PUT https://api.vimeo.com/me/projects/{folder_id}/videos/{video_id}
}





/////////////////////////////////////////////////////////////////////////
// CLIENT-SIDE:  TUS-JS-CLIENT RESUMABLE file upload
//
//  src:https://github.com/tus/tus-js-client/blob/master/demos/browser/video.js
//
var stopTusRecording   = null
var upload          = null
function tus_init() {
	if (!tus.isSupported) {
		console.log("tus.347:  TUS is not supported!")
	}

	if (stopTusRecording) {
		//recordBtn.textContent = 'Start Recording'
		stopTusRecording()
	} else {
		//recordBtn.textContent = 'Stop Recording'
		startTusStreamUpload()
	}
};


// WORKING VERSION: TERMINATE WEBCAM STREAMING UPLOAD SESSION STILL NOT WORK, NEED VIMEO CHG
//
// Tus upload heavy lifting
// src: https://developer.vimeo.com/api/reference/videos/3.4#complete_streaming_upload  (need to chk again)
var target_upload_size = 0;
function startTusUpload (file, file_size, uploadUrl, chunkSize) {
	if (isNaN(chunkSize)) {
		chunkSize = Infinity;
	}

    var Authorization = 'bearer '+VIMEO_BEARER_TOKEN;
	var options = {
			//resume              : false,
            Authorization,
			uploadUrl,
			chunkSize,
			retryDelays: [0, 1000, 3000, 5000],
			//uploadLengthDeferred: true,
			uploadLengthDeferred: false,        // only enable if we can stream
			metadata: { filename: 'webcam.webm',
                        filetype: 'video/webm',
                       },

            onError (error) {
                if (error.originalRequest) {
                    console.log(`tus.109:  ------- ERROR: Orig Failed because: ${error}`)
                } else {
                    console.log(`tus.393: ------ ERROR: Failed because: ${error}`)
                }
                tus_reset()

                /*
                tus.Upload.terminate(uploadUrl)
                .then(res => {
                    console.log("tus.120:  UPLOAD TERMINATED ",  res);
                    tus_reset();
                })
                options.uploadSize = bytesUploaded;
                upload = new tus.Upload(file, options)
                upload.start()
                */
            },

            onProgress (bytesUploaded) {
            //onChunkComplete (bytesUploaded) {
                if ((upload !== null) && (bytesUploaded < target_upload_size)) {
                    console.log("tus.397:  Uploaded "+bytesUploaded+" bytes out of ",target_upload_size);
                    INFO.progress_message = Math.floor(bytesUploaded / target_upload_size * 100) + "%";
                } else {
                    if (upload !== null) {
                        console.log("tus.196:  TUS PROGRESS REACHED! ", (bytesUploaded/1000), " KBytes");
                        tus_reset();
                    }
                }
            },

            onCompletion () {
                console.log("tus.201:  TUS UPLOAD COMPLETED!");
                tus_reset()
            },

            onSuccess () {
                console.log("tus.206:  TUS UPLOAD SUCCESS!");
                tus_reset()
            },
    }

    target_upload_size = file_size;
    console.log("tus.209:  tus.Upload   url=",options.uploadUrl, "  file=",(file !== null), " size=",target_upload_size);
    upload = new tus.Upload(file, options)
    upload.start()
}



// CORS VERSION  - NOT WORKING
// entry point to setup the upload
// Tus upload heavy lifting
function startCorsTusUpload (uploadUrl, file) {
    var options = {
            file: file,
            url: uploadUrl,
            token: VIMEO_BEARER_TOKEN,

            onError (error) {
                if (error.originalRequest) {
                    console.log(`ctus.189:  Orig Failed because: ${error}`)
                } else {
                    console.log(`ctus.191:  Failed because: ${error}`)
                }
            },

            //onChunkComplete (bytesUploaded) {}
            onProgress (bytesUploaded) {
                console.log("ctus.234:  Uploaded "+bytesUploaded+" bytes so far.");
            },

            onSuccess () {
                tus_reset()
            },
        }

    console.log("tus.150:  CORS.tus.Upload   options=",options," url=",uploadUrl, "  file=",file);
    var uploader = new CorsUploader(options);

    uploader.upload();
}



// entry point to setup the streaming upload
function startTusStreamUpload (url, file_size, chunkSize) {
    navigator.mediaDevices.getUserMedia({ video: true })
    .then(stream => {
        const mr = new MediaRecorder(stream)
        const chunks = []
        let done = false
        let onDataAvailable = null

        mr.onerror = tus_onError
        mr.onstop = () => {
            done = true
            console.log("tus.stop.154: STOPPING");
            if (onDataAvailable) {
                onDataAvailable(readableTusRecorder.read())
            }
        }
        mr.ondataavailable = event => {
            chunks.push(event.data)
            if (onDataAvailable) {
                onDataAvailable(readableTusRecorder.read())
                onDataAvailable = undefined
            }
        }

        mr.start(1000)

        const readableTusRecorder = {
            read () {
            if (done && chunks.length === 0) {
                return Promise.resolve({ done: true })
            }

            if (chunks.length > 0) {
                return Promise.resolve({ value: chunks.shift(), done: false })
            }

            return new Promise((resolve) => { onDataAvailable = resolve })	// TRICKY CODE!
            },
        }

        if(chunkSize === undefined) {
            chunkSize = 20000000;
        }
        startTusUpload(readableTusRecorder, file_size, url, chunkSize);   // need to CONSTS chunk size
        //startCorsTusUpload(url, readableTusRecorder);

        stopTusRecording = () => {
            stream.getTracks().forEach(t => t.stop())
            mr.stop()
            stopTusRecording = null
        }
    })
    .catch(tus_onError);
}


function tus_reset () {
    upload = null;
}

function tus_onError (error) {
  console.log("tus.466:  ERROR: ",error);

  upload = null
  stopTusRecording = null
}



/////////////////////////////////////////////////////////////////////////
// CLIENT-SIDE:  FIREBASE database records
//
// FINAL FIRESTORE DB WRITE FOR SESSION
// wait for the bucket writes to complete (may be multiple) , each time it will signal this routine
// when all writes are complete (if there is video), then it will write out the session record
//
export function storeAllSessionData() {
	var hbody = INFO.history_ready;
	var vbody = INFO.video_ready;
	var cbody = INFO.console_ready;
    var out = null;

	if ((INFO.validate_passed === false) || (INFO.history_ready === null)) {
        return  null;
    }

    hbody.public = false;
    if (INFO.make_record_public === true) {
        hbody.public = true;        // explicit permission to publish this session
    }

    if ((INFO.adhoc_mode === true) || (INFO.anon_mode === true) || (INFO.analyze_mode === true) || (INFO.execption_mode === true)) {
        hbody.no_score = true;      // for students and temp users, do not score
    }

    console.log("dbsave_sess.352:      . . . STORE ALL SESSION CHECK:    vid_running=",INFO.record_running, "  hist=", (hbody !== null), "  vid=", (vbody !== null), " cons=",(cbody!==null), " validated=",INFO.validate_passed);
	if ((hbody !== null) && (cbody !== null) && (INFO.validate_passed === true)) {
        // if not recording, or already has recording, then write session record to FB
        //if ((INFO.record_running === false) || ((INFO.record_running === true) && (vbody !== null))) {
            // both history and video bucket writes have completed
            //if (INFO.record_running === true) {
            if (vbody && vbody.video) {
                hbody.video = vbody.video;
                console.log("dbsave_sess.356:       . . . VIMEO_LINK: ", vbody.video);
            }

            hbody.console = cbody.console;      // pointer to console.log for DEBUG
            out = StoreSession(hbody)
                  .then((out) => {
                    console.log("dbsave_sess.366:   # # # # # # # #  ALL BUCKET WRITE COMPLETED   hist=", (hbody!==null),"  vid=", (vbody!==null));
                    INFO.db_scores = null;          // KLUDGE: ALWAYS FORCE A SCORE RE-READ
                    INFO.history_ready = null;
                    INFO.video_ready = null;
                    INFO.console_ready = null;
                    INFO.record_running = false;    // now we are done
                    INFO.validate_passed = false;
                    initCONSLOG();      // clear what is has written out

                    setTimeout(()=> { 
                        updateVimeoThumbnail(INFO.vimeo_link);      // give it some time to process
                    }, 30000)
                    window.dispatchEvent(INFO.finished_event);      // db write is done
                    return out;
                  })
        //}
	}

	return out;
}


// store completed video data to vimeo (was gcp buckets)
//
export async function StoreVideoFile(email, uid, blob) {
    var url, fname;

    var body = {};
    body.user_id = makeUserKey(email, "StoreVideoFile.382");
    body.uid = uid;
    body.timestamp = Math.floor(TIMES.session_start).toString();
    if (INFO.file_name == "_auto_") {
        fname = uid+"_"+body.timestamp+".webm";
    } else {
        fname = INFO.file_name + "_" + TIMES.session_start;
    }
    console.log('video.398:        . . . .  UPLOADING VIDEO TO VIMEO.... ', fname);

    var use_vimeo = true;
    if(use_vimeo === true) {
        INFO.validate_passed = false;       // wait until write is completed
        url = await storeVimeoFile(fname, blob);
    } else {
        // store in gcp bucket
        var bucket = "videos";
        if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
            bucket = "test_videos"
        }
        url = await bucket_store_blob(bucket, fname, blob);
    }

    body.video = url       // replace with just the link
    INFO.video_ready = body;
    INFO.validate_passed = true;       // ok to write session
    window.dispatchEvent(INFO.wakeup_db_event); // Dispatch the event.

    return body;
}



// key routine to create history record and store to bucket
//    - assembles session record here
//
export async function StoreHistoryBucket(email, uid, type) {
    var bucket = "sessions"; // type = "PRACTICE";
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        bucket = "test_sessions"
    }

    // extract HISTORY from the time session started (not webcam_start)
    var history = [];
    var record = false;
    for(var i=0; i < HISTORY.length; i++) {
        var hist = HISTORY[i];

        for(var j=0; j < hist.events.length; j++) {
            var event = hist.events[j];       // KLUDGE: NEED TO SEARCH ARRAY
            if (event !== undefined) {
                if (INFO.perf_mode === true) {
                    if (INFO.defender_mode === true) {
                        record = true;  // always record defender
                        type = "DEFENDER";
                    } else {
                        //console.log("event.53:       ", i, "  ",j, "  event=",event);
                        if ((event.indexOf("START") >= 0) || (event === "CALIB")) {
                            record = true;
                            console.log("hist.56: ++++++ START FRAME ", i);     // if not START then we assume it's PRACTICE?
                            type = "PERFORMANCE";
                        }
                        if (event === "STOP") {
                            record = false;
                            console.log("hist.60: ------ STOP FRAME ", i);
                            type = "PERFORMANCE";
                        }
                    }
                }

                if ((INFO.practice_mode === true) && (record === false)) {
                    //console.log("hist.106: ++++++ ALWAYS ON FOR PRACTICE MODE ", i);
                    record = true;      // for now, always turn on
                    type = "PRACTICE";
                }

                if (INFO.dev_analyze_mode === true) {
                    //console.log("hist.449: ++++++ ALWAYS ON FOR ANALYZE DEV MODE ", i);
                    //if (event.indexOf("START") >= 0) {
                        record = true;      // only record the history when there is video
                        type = "REPLAY";
                    //}
                }
            }
        }




        HISTORY[i].pose.keypoints = [];     // MEGA KLUDGE: DELETE THEM FOR NOW, NEED TO COMPRESS THEM INSTEAD
        HISTORY[i].pose.keypoints3D = [];     // MEGA KLUDGE: DELETE THEM FOR NOW, NEED TO COMPRESS THEM INSTEAD





        if(record === true) {
            history = history.concat(HISTORY[i]);
        }
    }
    console.log("hist.54:  ***** type=",type, "  out=",history.length, "  orig=",HISTORY.length);   //, "  ", history);
    console.log("hist.55:  ***** start=",TIMES.start_session, "  stop=",TIMES.stop_session);
    //if(INFO.bug_report !== "") {
    //    type = "BUG";
    //}

    var session_body = createSessionBody(email, uid, type);
    session_body.frames = history;
    session_body.frame_count = history.length;
    if(INFO.bug_report !== "") {
        session_body.bug_report = INFO.bug_report;
    }

    switch (type.toLowerCase()) {
        case "replay":
            session_body.disable_update = true;     // not a real record
            break;
    }

    var body_text =  JSON.stringify(session_body);
    var fname = uid+"_"+session_body.timestamp+".sess";

    var url = await bucket_store_string(bucket, fname, body_text);
    session_body.frames = url       // replace with just the bucket link
    INFO.session_timestamp = session_body.timestamp;        // trail to store video url

    INFO.history_ready = session_body;
    window.dispatchEvent(INFO.wakeup_db_event);    // History is writtent to db bucket

    return session_body;
}


// key routine to create a game or analysis debug record and trigger a write to db
//    - assembles session record here
//
export async function CreateVirtualSession(email, uid, type) {
    var bucket = "sessions"; //type = "PRACTICE";
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        bucket = "test_sessions"
    }

    StoreConsoleLogBucket(INFO.email, INFO.uid);

    var session_body = createSessionBody(email, uid, type);
    if(INFO.bug_report !== "") {
        session_body.bug_report = INFO.bug_report;
    }

    // need to pull in actual HISTORY if dev analayze of videos
    if (type === "replay") {
        StoreHistoryBucket(email, uid, type);       // disable_update set in here
    } else {
        INFO.history_ready = session_body;
        window.dispatchEvent(INFO.wakeup_db_event);    // wakeup db write routine
    }

    return session_body;
}


// store completed video data into buckets
//
export async function StoreConsoleLogBucket(email, uid) {
    var url;

    var body = {};
    body.user_id = makeUserKey(email, "StoreConsoleLogBucket.508");
    body.uid = uid;
    body.timestamp = Math.floor(TIMES.session_start).toString();

    // store in gcp bucket
    var bucket = "conslog";
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        bucket = "test_conslog"
    }

    var fname = uid+"_"+body.timestamp+".clog";
    console.log('clog.512:  UPLOAD CONSOLE.LOG ', fname);
    url = await bucket_store_string(bucket, fname, CONSLOG);
    body.console = url       // replace with just the link

    INFO.console_ready = body;
    window.dispatchEvent(INFO.wakeup_db_event);    // History is writtent to db bucket
    return body;
}



// store frame history data into buckets first
//
function createSessionBody(email, uid, type) {
    var now = Date.now();
    var start_time = (TIMES.session_start > 0) ? new Date(TIMES.session_start) : new Date(now);

    var body = {};
    body.user_id = makeUserKey(email, "createSessionBody.542");
    body.uid = uid;

    body.version = CONSTS.AXOS_DATA_VERSION;
    body.user_agent = INFO.user_agent;
    body.ip_info = INFO.ip_info;
    body.user_location = INFO.user_location;
    body.axos_version = INFO.axos_version;
    body.device = INFO.device;
    body.browser = INFO.browser;
    body.type = type.toUpperCase();
    body.mode = sessionMode(email);        // for easy index searching
    body.name = INFO.session_name;         // name of the practice
    body.drill_hash = INFO.drill_hash;     // drill hash
    body.tz_offset = new Date().getTimezoneOffset();        // in minutes from UTC (UTC+1 == -60, PST == UTC-7 == +(60 *7))
    body.timestamp = Math.floor(TIMES.session_start).toString();
    body.date = start_time.toISOString();

    body.width = INFO.video_width;
    body.height = INFO.video_height;

    body.completed = INFO.session_completed;     // only if the session was done with good quality
    //body.frames = history;
    //body.frame_count = HISTORY.length;
    switch (type) {
        case "game":
            body.runs = RUNS;       // summary of all the simulated runs
            break;
        case "mock":
            body.runs = RUNS;       // summary of all the simulated runs
            body.footage_timeline = INFO.mock_timeline;
            body.footage_time = INFO.mock_detect_time;
            break;
        case "exception":
            body.exception = true;       // summary of all the simulated runs
            break;
    }
    //body.runs = RUNS;       // summary of all the runs, includes turns
    var body1 = {...body};
    body = mergeSTATSSummary(body1);
    console.log("hist.112:   * * * CREATE SESSION BODY  start_time=", start_time, " user_id=",body.user_id, " email=",email, " uid=", uid, " type=",type, " body=",body);

    return body;
}



// run: https://cors-anywhere.herokuapp.com/corsdemo TO ENABLE CORS
const cors_proxy_url="https://cors-anywhere.herokuapp.com/"
//const cors_proxy_url="https://axos.cc:8888/";       // supports REST call from localhost

// store history record to axos REST server, if localhost use cors_proxy
export function StoreSession(body) {
    var cmd = "/sessions/create/_auto_";
    var url = NODE_API_SERVER+cmd;

    var res = postURL(url, body)
                .then(res => {
                    return res;
                })
    return res;
}




/////////////////////////////////////////////////////////////////////////
// CLIENT-SIDE:  FIRBASE MODULE OBJECT READ
//

export async function CreateDatabase(table, uid, body) {
    var cmd = "/"+table+"/create/"+uid;
    var url = NODE_API_SERVER+cmd;

    console.log("createDB.631:          .  .  .  . CREATE RECORD    ", table.toUpperCase(), ": uid=", uid);
    var res = await postURL(url, body)
                .then(res => {
                    if(res.output !== undefined) {
                        console.log("createDB.635:          .  .  .  .  SUCCESS:  RECORD CREATED,   ", table.toUpperCase(), ": res=", res);
                    }
                    return res.output;
                })
    return res;
}


// pass uid to lower primitives, but client-side should also be single user
//
export async function ReadDatabase(table, uid, body) {
    var cmd = "/"+table+"/read/"+uid;
    var url = NODE_API_SERVER+cmd;

    var res = await postURL(url, body)
                .then(res => {
                    if(res.output !== undefined) {
                        var uid1 = uid;
                        if (body.search !== undefined) {
                            uid1 = body.search[0]+" " + body.search[1]+" "+body.search[2];
                        }
                        //console.log("readDB.671:          .  .  .  .  FROM DB ===> ", table.toUpperCase(), ": ", uid1, " ",res.output.length, " records");
                    }
                    return res.output;
                })
    return res;
}




// read drills for this user
//
export async function ReadDrillData(mode, key) {
    var body = null;
    // two modes:  for daily need to read sequences, for browing need to read drills
    //      - sequence: use user_id
    //      - drills: use user_id => memberships => orgs => drills (???)
    switch(mode){
        case "today":
            body = {"search": ["org_key", "==", INFO.org_key]};
            break;

        case "single":
            body = {"search": ["key", "==", key]};
            break;

        default:
            body = {"search": ["org_key", "==", INFO.org_key]};
            break;
    }

    var out = await ReadDatabase("drills", "_search_", body)
        .then(adrills => {
            if((adrills === null) || (adrills === undefined)) {
                return [];
            }
            adrills.sort(arraySeqAscSort);
            return adrills;
        });

    return out;
}



// read drills for this user
//
export async function ReadMenuData() {
    // read menu data, configure sub-menu
    //      - sequence: use user_id
    //      - drills: use user_id => memberships => orgs => drills (???)

    //var body = {"search": ["org_id", "==", "master:axos:9233"]};    // TODO: should we use user_id to fetch?
    var body = {"search": ["org_key", "==", INFO.org_key]};
    var out = await ReadDatabase("menus", "_search_", body)
        .then(menus => {
            var out = [];
            if((menus === null) || (menus === undefined)) {
                return [];
            }
            menus.sort(arraySeqAscSort);
            return menus;
        });

    return out;
}




// read tabs for this user
//
export async function ReadSectionData() {



    // TODO: USERS HAVE SECTIONS FROM MULTIPLE ORGS!!
    //     - Need a wrapper API that returns all data types based on memberships!!!!!
    //


    // two modes:  for daily need to read sequences, for browing need to read drills
    //      - sequence: use user_id
    //      - drills: use user_id => memberships => orgs => drills (???)
    //var body = {"search": ["org_id", "==", "master:axos:9233"]};
    var body = {"search": ["org_key", "==", INFO.org_key]};
    var out = await ReadDatabase("sections", "_search_", body)
            .then(sections => {
                var out = [];
                if((sections === null) || (sections === undefined)) {
                    return [];
                }
                sections.sort(arraySeqAscSort);

                //console.log("get_section_db.752:  sections=", sections);
                return sections;
            });

    return out;
}


// read motions for finger games
//
export async function ReadMotionData() {
    //var body = {"search": ["org_id", "==", "master:axos:9233"]};
    var body = {"search": ["org_key", "==", INFO.org_key]};
    var out = await ReadDatabase("motions", "_search_", body)
            .then(motions => {
                var out = [];
                if((motions === null) || (motions === undefined)) {
                    return [];
                }
                //console.log("get_section_db.771:  sections=", sections);
                return motions;
            });

    return out;
}


// read user home org (for branding)
//
export async function ReadHomeOrgData(user_hash) {
    var body = {"search": ["hash", "==", user_hash]};
    var users = await ReadDatabase("users", "_search_", body)

    var out = await ReadDatabase("orgs", users[0].home_org_id, {})
            .then(orgs => {
                return orgs;
            })
    return out;
}



// read aux states
//
export async function ReadStateData(owner_hash) {
    var body = {"search": ["owner_hash", "==", owner_hash]};
    var out = await ReadDatabase("auxs", "_search_", body)
            .then(states => {
                //console.log("read_state_data.856:      = = = =  owner_hash=",owner_hash, " states==", states);
                if((states === null) || (states === undefined)) {
                    return [];
                }
                return states;
            });

    return out;
}



// read aux leaders
//
export async function ReadLeaderData(owner_hash) {
    var body = {"search": [owner_hash, "!=", ""]};
    var out = await ReadDatabase("auxs", "_search_", body)
            .then(states => {
                var out = [];
                if((states === null) || (states === undefined)) {
                    return [];
                }
                //console.log("get_section_db.823:  sections=", sections);
                return states;
            });

    return out;
}



// read customer player sequences
//
export async function ReadTodayData() {
    var body= {"search": ["owner_id", "==", INFO.email]};

    var out = await ReadDatabase("sequences", "_search_", body)
            .then(sequences => {
                var out = [];
                if((sequences === null) || (sequences === undefined)) {
                    return [];
                }
                return sequences;
            });

    return out;
}

// pass uid to lower primitives, but client-side should also be single user
//
export async function ReadSession(uid, body) {
    var cmd = "/sessions/read/"+uid;
    var url = NODE_API_SERVER+cmd;
    var res = await postURL(url, body)
                .then(res => {
                    if(res.output !== undefined)
                        //console.log("sess.724: sess[0]:", res.output[0]);
                        //console.log("readSess.687:         .  .  .  .  Received Session Records  res=",res.output.length);
                    return res.output;
                })
    return res;
}

//
export async function UpdateSession(uid, body) {
    //var cmd = "/sessions/update"+uid;
    var cmd = "/sessions/update/"+uid;
    var url = NODE_API_SERVER+cmd;
    var res = await postURL(url, body)
                .then(res => {
                    console.log("db.800: UpdateSession RETURN :", res);
                    return res.output;
                })
    return res;
}



// special code to get bucket copy of the video
//     - do this so we can run AI on it (youtube player disallow that)
//
export async function GetBucketVideoLink(video_hash, mock_type) {
    var cmd = "/bucket/video/"+video_hash+"?exist";
    var url = NODE_API_SERVER+cmd;
    console.log("chklink.858:           .  .  .  .  url=",url);
    var res = await getURL(url)
                .then(res => {
                    //if(res.output !== undefined)
                    //return res.output;
                    console.log("chklink.865:           .  .  .  .  Received Link Data  res=",res);
                    return res.link;
                })
    return res;
}



// read detect metadata for a <video>
//    - use this for simulation runs
//
export async function CreateDetect(vid, body) {
    var cmd = "/detects/create/"+vid;
    var url = NODE_API_SERVER+cmd;
    var res = await postURL(url, body)
                .then(res => {
                    if(res.output !== undefined)
                        console.log("readSess.838:  ++++++++++++++++++++++++ CREATED Detect Record  res=",res.output.length);
                    return res.output;
                })
    return res;
}

export async function ReadDetect(vid) {
    var cmd = "/detects/read/"+vid;
    var url = NODE_API_SERVER+cmd;
    var res = await postURL(url, {})
                .then(res => {
                    if(res.output !== undefined)
                        //console.log("readSess.850:           .  .  .  .  Received Detect Records  res=",res.output.length);
                    return res.output;
                })
    return res;
}


export async function ReadFootageDetect(user_id, mock_type) {
    var cmd = "/footage/"+user_id+"/"+mock_type;
    var url = NODE_API_SERVER+cmd;
    console.log("footage.861:           .  .  .  .  url=",url);
    var res = await getURL(url, {})
                .then(res => {
                    //if(res.output !== undefined)
                    //return res.output;
                    if(res.output !== undefined)
                        //console.log("readSess.850:           .  .  .  .  Received Detect Records  res=",res.output.length);
                    return res.output;
                })
    return res;
}


// insert an element into array
//     - "<collection>/insert/<id>": 
//           * body: { field: <field_name_contain_array>, data: <object_to_be_inserted>}
//
export async function InsertTargetDetect(vid, body) {
    var cmd = "/detects/insert/"+vid;
    var url = NODE_API_SERVER+cmd;
    var res = await postURL(url, body)
                .then(res => {
                    console.log("db.852: Detect INSERT RETURN :  cmd=",cmd, " body=",body);
                    return res.output;
                })
    return res;
}


// delete an element from array
//     - "<collection>/insert/<id>": 
//           * body: { field: <field_name_contain_array>, data: <object_to_be_inserted>}
//
export async function RemoveTargetDetect(vid, body) {
    var cmd = "/detects/delete/"+vid;
    var url = NODE_API_SERVER+cmd;

    console.log("db.907:   +++++++++ REMOVE TARGET DETECT cmd=", cmd, "  body=",body);
    /*
    var res = await postURL(url, body)
                .then(res => {
                    console.log("db.852: Detect INSERT RETURN :", res);
                    return res.output;
                })
    return res;
    */
}


export async function dbUpdateTutorialState(uid, body) {
    var cmd = "/auxs/update/"+uid;
    var url = NODE_API_SERVER+cmd;
    var res = await postURL(url, body)
                .then(res => {
                    console.log("db.811: dbUpdateTutorialState RETURN :", res);
                    return res.output;
                })
    return res;
}


export async function dbCheckInviteKey(key) {
    var cmd = "/user/verify/"+key+"/00";
    var url = NODE_API_SERVER+cmd;
    var res = await getURL(url)
                .then(res => {
                    console.log("db.822:  dbCheckInviteKey RETURN :", res);
                    return res.output;
                })
    return res;
}




// returns session videos for this user, this is client-side always assume single user
//
export async function fetchSessionVideoLinks() {
    var out = [], body = {};
    var uid = (INFO.anon_mode === true) ? INFO.anon_uid : INFO.uid;
    var body = {"search": ["uid", "==", uid], "order_by": "timestamp", "direction": "desc", "max_read": 30}; 
    var out = await ReadSession("_search_", body)
                .then(sessions => {
                    if(sessions == null) {
                        return [];
                    }
                    sessions.sort(arrayTimestampDesSort);        // latest date on top
                    for (var i = 0; i < sessions.length; i++) {
                        var session = sessions[i];
                        var new_date = new Date(session.date);
                        var data = {};
                        data.video = session.video;
                        data.date = new_date.toLocaleString();
                        data.name = session.name;
                        data.width = (session.width) ? session.width : 600;       // KLUDGE: VIMEO HARD CODE
                        data.height = (session.height) ? session.height : 370;

                        //console.log("getvid.29: ",i,"  session = ", session);
                        if(data.video !== undefined) {
                            out.push(data);
                        }
                    }
                    return out;
                })

    //console.log("getvid.33: video links = ", out)
    return out;

}



// returns newly created drills (subtype == "new")
//     - this is used in Analyze->Preview to collect Motion Marker info
//
export async function fetchNewDrillLinks() {

    var body = {"search": ["subtype", "==", "new"]};
    var drills = await ReadDatabase("drills", "_search_", body)
                    .then( drills0 => {
                        //var drills = processDrillItems(drills0);
                        //setAllDrills(drills);
                        return drills0;
                    });
    console.log("getfoot.1053:                * * * * * *  FETCH NEW DRILLS   ", drills);
    return drills;
}


// return drills
//
export async function fetchProgSequences(prog_hash) {

    var search1 = {"search": ["hash", "==", prog_hash]};
    var progs = await ReadDatabase("programs", "_search_", search1)
    var seq_hash = (progs[0]) ? progs[0].flow_hash : null;

    if (seq_hash) {
        var search2 = {"search": ["flow_hash", "==", seq_hash]};
        var drills = await ReadDatabase("sequences", "_search_", search2)
                        .then( drills0 => {
                            //var drills = processDrillItems(drills0);
                            //setAllDrills(drills);
                            return drills0;
                        });
        console.log("getseq.1874:                * * * * * *  FETCH PROG SEQEUNCES   seq_hash=",seq_hash," drils=", drills);
        return  drills;
        //return [ drills, progs[0] ];
    } else {
        return null;
        //return [null, null];
    }
}




//////////////////////////////////////////////////////////////////////////
//   MSGS RELATED
//

// get class setup from pass msgs
//    - need a way to reset the class membership
//
export async function fetchClassSetup(group_id) {
    //var body = {"search": ["users_hash", "==", class_hash], "max_read": 40};
    var body = {"search": ["group_id", "==", group_id], "order_by": "timestamp", "direction": "desc", "max_read": 40}; 
    //var body = {"search": ["group_id", "==", group_id], "order_by": "issued", "direction": "desc", "max_read": 40}; 
    var msgs = await ReadDatabase("msgs", "_search_", body);       // this is per device
    //var msgs = msgz.filter(msg => { return msg.subtype == subtype });

    console.log("getmsg.1094:                * * * * * *  FETCH MSGS   group_id=",group_id," msgs=", msgs);
    return msgs ;
}


// bot admin master, call server to create setup Msg
//     - 
//
//export async function updateClassSetup(uid, class_hash, prog_hash, device_hash) {
export async function updateClassSetup(mode, uid, name, prog_hash, device_hash, user_list, device_list, group_id) {
    //var cmd = "/user/bot/setup/"+uid;
    var cmd = "/bot/setup/"+uid;
    var url = NODE_API_SERVER+cmd;

    var body = {}
    body.mode = mode;       // could be ["class", "prog", "start"]
    body.users_hash = name;
    body.prog_hash = prog_hash;
    body.devices_hash = device_hash;
    body.users_group = user_list;
    body.devices_group = device_list;
    if (group_id) { body.group_id = group_id; }

    switch (mode) {
        case "class":
            body.cname = name;    // KLUDGE: FIELD OVERLOAD FOR class_name
            break;
    }


    console.log("createDB.1112:          .  .  .  . CREATE CLASS SETUP MSG   /bot/setup   uid=", uid, " body=",body, " group_id=",group_id);
    var res = await postURL(url, body)
                .then(res => {
                    if(res.output !== undefined) {
                        console.log("createDB.635:          .  .  .  .  SUCCESS:  RECORD CREATED,   /bot/setup : res=", res);
                    }
                    return res.output;
                })
    return res;
}


// send to backend to create new user in class
//     - this is used in prog mode, to support on-field adhoc user add (tryouts)
//     - backend will update the "prog" msg if the drills are run in prog mode
//     - pass in drill_hash, this will attach to the right msg (most likely "prog")
//
// FIXED-KLUDGE: Using this to create a class "shell"
// Note: We should merge this with "/setup", basically process create and update thru same API
//
export async function SendNewUser(mode, class_hash, prog_hash, device_hash, drill_hash, group_id, input) {
    var cmd1 = "/bot/add_user/"+class_hash;
    var url = NODE_API_SERVER+cmd1;

    var body = {}
    body.mode = mode;       // "class", "adhoc",  - need to merge with the setup.type
    body.users_hash = class_hash;
    body.prog_hash = prog_hash;
    body.devices_hash = device_hash;
    body.drill_hash = drill_hash;
    body.user_id = (input.user_id) ? input.user_id : "";
    body.group_id = group_id;

    switch (mode) {
        case "class":
            body.cname = input.cname;
            break;

        case "adhoc_user":    // adhoc field add user
            body.fname = input.fname;
            body.lname = input.lname;
            body.team = input.team;
            break;
    }

    console.log("send_msg.1157:          .  .  .  . CREATE NEW ",mode.toUpperCase(),"  url=",url, " class_hash=", class_hash, " group_id=",body.group_id,  " body=",JSON.stringify(body));
    var res = await postURL(url, body)
                .then(res => {
                    if(res.output !== undefined) {
                        console.log("createDB.1138:          .  .  .  .  SUCCESS:  RECORD CREATED,   ",cmd1," : res=", res);
                    }
                    return res.output;
                })
    return res;

}


// bot master issue drill start or stop cmd
//     - pass in drill_hash
//
export async function SendMsg(cmd0, mode, uid, drill_hash, class_hash, prog_hash, device_hash, group_id, user_list) {
    var cmd1 = "/bot/"+cmd0+"/"+uid;
    var url = NODE_API_SERVER+cmd1;

    var body = {}
    body.mode = mode;
    body.users_hash = class_hash;
    body.prog_hash = prog_hash;
    body.devices_hash = device_hash;
    body.drill_hash = drill_hash;
    body.group_id = group_id;
    if (user_list) { body.users_group = user_list };
    //body.group_id = (INFO.bot_setup) ? INFO.bot_setup.group_id : null;     // for stats id

    console.log("send_msg.1214:          .  .  .  . CREATE DRILL MSG   cmd0=",cmd0," url=",url, " uid=", uid, " group_id=", group_id, " body=",JSON.stringify(body));
    var res = await postURL(url, body)
                .then(res => {
                    if(res.output !== undefined) {
                        console.log("createDB.1138:          .  .  .  .  SUCCESS:  RECORD CREATED,   ",cmd1," : res=", res);
                    }
                    return res.output;
                })
    return res;

}


// get Msg left by Master
//    - also send back player run stats
//    - server will aggregate and send back to all devices
//
export async function GetMsg(type, uid, last_msg, group_id) {
    var cmd = "/bot/get/"+uid;
    var url = NODE_API_SERVER+cmd;

    var last_msg_id = null;
    var last_timestamp = null;
    if (last_msg) {
        last_msg_id = last_msg.msg_id;
        last_timestamp = last_msg.timestamp;
    }

    var body = {}
    body.last_msg_id = last_msg_id;
    body.last_read = last_timestamp;

    body.drill_hash = (INFO.bot_run_mode === "prog") ? CONSTS.BOT_DRILL_START_HASH : INFO.drill_hash;
    body.users_hash = INFO.bot_active_class_hash;
    body.group_id = group_id;
    body.set = INFO.drill_set_cnt;      // for stats id

    body.mode = type;
    if (INFO.bot_run_mode === "prog") { body.mode = "prog" };
    //if (type === "class") { body.group_id = null; }   DO NOT DO THIS

    // send in the player stats from the run
    //   - Use RUNS?
    if (INFO.bot_stats && (Object.keys(INFO.bot_stats).length > 0)) {
        body.stats = Object.assign({}, INFO.bot_stats);  // copy object, save it for bot remote control
        console.log("get_msg.1190:          REPORT STATS:  url=",url, " group_id=", body.group_id, " bot_all_stats=",INFO.bot_all_stats," msg_body.stats=", JSON.stringify(body), " bot_run_mode=",INFO.bot_run_mode);
    }
    INFO.bot_stats = {};        // clear this individual stat for the next one


    var res = await postURL(url, body)
                .then(res => {
                    if(res.success !== undefined) {
                    }
                    return res.success;
                })
    console.log("get_msg.1169:          .  .  .  .  GET MSG:  /bot/get:  msg.cmd=",((res) ? res.cmd : null), " last_msg_id=",last_msg_id, "  last_read=", last_timestamp, " cmd=",res);    //, " body=",body, " msg=",res);
    return res;

}





//////////////////////////////////////////////////////////////////////////
//   MEMBERSHIP RELATED
//

// returns members
//     - 
//
export async function fetchGroupMembers(owner_hash) {
    var body = {"search": ["owner_hash", "==", owner_hash]};
    var membs = await ReadDatabase("memberships", "_search_", body)
    console.log("getgroup.1095:                * * * * * *  FETCH MEMBERSHIPS  owner_hash=",owner_hash," membs=", membs);
    return membs ;
}


// returns setups msgs
//     - Note: this is not the same as the group.class definitions (which should be roster)
//
export async function fetchClassSetupList() {
    var body = {"search": ["subtype", "==", "setup"], "order_by": "timestamp", "direction": "desc", "max_read": 40}; 
    var sessions = await ReadDatabase("msgs", "_search_", body)
    console.log("getgroup.1070:                * * * * * *  FETCH CLASS SESSION ", sessions);
    return sessions ;
}



// returns groups list defined in db
//     - supported: "class" (to rename to "roster"), "devices", "programs"
//
export async function fetchGroupList(type) {
    var body = {"search": ["type", "==", type]};
    var groups = await ReadDatabase("groups", "_search_", body)
    console.log("getgroup.1070:                * * * * * *  FETCH GROUPS ", groups);
    return groups ;
}


// returns progrms used for clinics
//     - 
//
export async function fetchProgram(prog_hash) {

    var body = {"search": ["hash", "==", prog_hash]};
    var programs = await ReadDatabase("programs", "_search_", body)
    console.log("getprogs.1087:                * * * * * *  FETCH PROGRAMS ", programs);
    return programs[0];
}


// returns progrms used for clinics
//     - 
//
export async function fetchProgramList(type) {

    //var body = {"search": ["type", "==", "drills"]};      // for testing
    var body = {"search": ["subtype", "==", type]};
    var programs = await ReadDatabase("programs", "_search_", body)
    console.log("getprogs.1087:                * * * * * *  FETCH PROGRAMS ", programs);
    return programs ;
}




// returns session videos for this user, this is client-side always assume single user
//
export async function fetchFootageLinks(type, subtype) {
    var out = [], body = {};
    var body = {"search": ["type", "==", type]};
    console.log("getfoot.980:                * * * * * *  FETCH FOOTAGE    type=", type, " subtype=",subtype);
    var out1 = await ReadDatabase("footages", "_search_", body)
                .then(footages => {
                    if(footages == null) {
                        return [];
                    }

                    if ((subtype === "cond") || (subtype === "drill") || (subtype === "conds") || (subtype === "drills")) {
                        footages.sort(arrayTimestampDesSort);        // earlies timeline on top
                    } else {
                        footages.sort(arrayTimelineAscSort);        // earlies timeline on bottom
                    }
                    for (var i = 0; i < footages.length; i++) {
                        var footage = footages[i];
                        if (subtype && (subtype !== footage.subtype)) {
                            continue;       // skip if not subtype match
                        }
                        //console.log("getfoot.995:             .  .  .  .  ",i,"  subtype=",subtype, " footage = ", footage);

                        var data = {};
                        data.hash = footage.hash;
                        data.source = footage.source;
                        data.video_id = footage.video_id;
                        data.type = footage.type;
                        data.title = footage.title;
                        data.width = footage.width;
                        data.height = footage.height;
                        data.subtype = footage.subtype;
                        data.enabled = (footage.enabled) ? footage.enabled : false;

                        if ((data.video_id !== undefined) && (data.enabled === true)) {
                            out.push(data);
                        }
                    }
                    return out;
                })

    console.log("getfoot.1030:   = = = = = = = = =   GOT FOOTAGE video links = ", out1.length);
    return out1;

}



// returns the performance data [] for this drill, both for the user and the world
//
export async function FetchFirestoreDrillSummary(drill_hash, fields) {
    var out = [], body = {};
    if (fields == undefined)  {
        return null;
    }

    // get personal records
    //
    //var body = {"search": ["user_id", "==", email], "max_read": INFO.HISTORY_MAX_READ };
    //var hash = (INFO.anon_mode === true) ? makeUserHash(INFO.anon_email) : makeUserHash(INFO.email);
    //var key = (INFO.anon_mode === true) ? makeUserKey(INFO.anon_email) : makeUserKey(INFO.email);
    var hash = (INFO.anon_mode === true) ? makeUserHash(INFO.anon_email) : makeUserHash(INFO.email);
    var body = {"search": ["cluster_hash", "==", hash ] };
    var out1 = await ReadDatabase("stats", "_search_", body)
              .then(astats => {
                    if((astats === null) || (astats === undefined)) 
                        return [];

                    var records = ExtractTopRecords(astats, drill_hash, fields, "player");
                    var out=records[0];
                    //console.log("drill_sum.793:         PERSONAL RECORD1  cluster_has=",hash, " records=",records);
                    //console.log("drill_sum.794:         PERSONAL RECORD2  field=",out.field, " value=",out.value, "  type=",out.type, " next_rec=",out.next_rec, "  limit_rec=",out.limit_rec,"  ",out.timestamp);
                    INFO.personal_record = Object.assign({}, out);      // copy object
                    return records;
                })


    // TODO
    // out.next_rec     // must beat this to make new record
    // out.limit_rec    // can't exceed this



    // get world record
    //
    var body = {"search": ["cluster_hash", "==", "geo:world:_:_:_"] };
    var out2 = await ReadDatabase("stats", "_search_", body)
              .then(astats => {
                    if((astats === null) || (astats === undefined)) 
                        return [];

                    var records = ExtractTopRecords(astats, drill_hash, fields, "world");
                    var out=records[0];
                    //console.log("drill_sum.813:         WORLD RECORD  field=",out.field, " value=",out.value, "  type=",out.type, " name=",out.name, "  ",out.timestamp);
                    INFO.world_record = Object.assign({}, out);  // copy object
                    return records;
                })

    var out = Promise.all([ out1, out2 ]).then((values) => {
        // [{"type": "world", "field": "---", "value": "---", "timestamp": "NONE" }]
        var out = []
        var pout = values[0];
        var wout = values[1];
        out[0] = wout[0];
        out[1] = pout[0];
        //console.log("drill_sum.916: -  -  -  -  -  -  -  -  -  -  -  -  -  -   PERSOANL RECORD   pout=",pout);
        return out;
    })
    return out;
}



// process Stats from DB and return record per numbers
//
function ExtractTopRecords(astats, drill_hash, fields, type) {
    //console.log("get_drill_hist.824:       TOTAL STATS      hash=_",drill_hash,"_  len=",drill_hash.length,"   ",astats);
    var stats = astats.filter(stat => {
        //console.log("get_drill_hist.826:          ",(stat.drill.trim() === drill_hash.trim()),"        drill=_",stat.drill, "_  len=",stat.drill.length,"   target= ", stat.target);
        if (stat.drill == drill_hash) {
            console.log("get_drill_hist.828:         drill=",stat.drill, " ", stat.target, "=",stat[stat.target], " user_id=",stat.user_id,"  cnt=",stat[stat.target+"_cnt"], " ",stat.timestamp );
        }
        return (stat.drill == drill_hash)
        //return ((stat.cluster_hash == email) && (stat.drill == drill_hash));     // return only for this drill
    })

    //console.log("get_drill_hist.834:       .  .  .  .  FILTERED STATS        ",stats.length);
    var records = []
    var value = null, next_rec = null, limit_rec = null, avatar = null, name = "unknown", timestamp = null, low_value = 999999;
    for(var j = 0; j < fields.length; j++) {
        var field = fields[j];
        for(var j = 0; j < stats.length; j++) {
            var stat = stats[j];
            if ((stat.target == field) && (stat[field] < low_value) && (stat[field] > 0)) {
                value = stat[field];
                timestamp = stat["timestamp"];
                if ((INFO.anon_mode === true) && (type === "player")) {
                    console.log("get_drill_hist.848:       ANON AVATAR  type=",type, "  anon_mode=",INFO.anon_mode, " field=",field);
                    //avatar = INFO.anon_avatar;
                    //name = INFO.anon_name;
                    avatar = "";        // no record yet, show blank 
                    name = "open";
                } else {
                    avatar = stat["user_avatar"];
                    name = stat["user_name"];
                    next_rec = stat["next_rec"];
                    limit_rec = stat["limit_rec"];
                }
                low_value = value;
            }
        }

        var record = {};
        record.field = (field === undefined) ? "NONE" : field;
        record.value = (value === null) ? "---" : tidyNumber(value);
        record.next_rec = tidyNumber(next_rec);
        record.limit_rec = tidyNumber(limit_rec);
        record.timestamp = timestamp;
        record.type = type;
        record.name = name;
        record.avatar = (avatar === null) ? INFO.anon_avatar : avatar;
        if(type === "player") {
            record.avatar = INFO.avatar;
        }
        records.push(record);
    }
    //console.log("driil.history.1493:  FINAL  out=", JSON.stringify(records));
    return records;
}



// OBSOLETE: OLD WAY OF READING SESSION => SWITCHED TO USING STATS INSTEAD
//
// KLUDGE: pass in both hash and name during transition time
export async function FetchFirestoreDrillHistory(drill_hash, drill_name) {
    var out = [];
    if (!drill_hash || !drill_name) {
        return null;
    }

    var uid = (INFO.anon_mode === true) ? INFO.anon_uid : INFO.uid;
    var search = ["uid", "==", uid];
    var out = await ReadSession("_search_", {"search": search})
            .then(asessions => {
                var out = [];
                if((asessions === null) || (asessions === undefined)) {
                    return [];
                }

                //console.log("get_drill_hist.729:  drill=", drill, "  asessions=", asessions.length, asessions);
                var sessions = asessions.filter(session => {
                    var status = false;
                    var drill_hash1 = (session.drill_hash) ? session.drill_hash.toLowerCase() : null;
                    //console.log("get_drill_hist.731:                 name=",session.name.toLowerCase(), "  match = ", (drill.toLowerCase() == session.name.toLowerCase())); 
                    //if ((session.drill_hash !== undefined) && (session.drill_hash.toLowerCase() == drill_hash.toLowerCase())) {
                    if (drill_hash1 === drill_hash.toLowerCase()) {
                        status = true;      // Check drill_hash which accounts for version
                    } else if ((session.name) && (drill_name) && (session.name.toLowerCase() == drill_name.toLowerCase())) {
                        status = true;      // KLUDGE: TRANSITION-ONLY, NEED TO CHECK HASH ONLY (has version)
                    }
                    return (status);        // return only for this drill
                })
                //console.log("get_drill_hist.733:  drill=", drill, "  sessions=", sessions.length);  // , "  ",sessions);

                if(sessions == null) {
                    return [];
                }
                sessions.sort(arrayTimestampAscSort);        // latest date on top
                for (var i = 0; i < sessions.length; i++) {
                    var session = sessions[i];
                    var new_date = new Date(session.date);
                    var data = isolatePerfSummary(session);
                    data.date = new_date.toLocaleString();
                    data.idx = i;
                    out.push(data);
                    //console.log("get_drill.648:    ",i,"       data=", data);
                }
                //console.log("get_drill.767:  out=", out[0]);
                return  out;
            })
            
    //console.log("get_drill.771:  out=", out[0]);
    return out;
}



// user with an invite link, call server to setup tables
//     - 
//
export async function inviteUser(uid, invite_key) {
    //var cmd = "/user/invite/"+INFO.uid+"/"+invite_key;
    var cmd = "/user/invite/"+uid+"/"+invite_key;
    var url = NODE_API_SERVER+cmd;

    console.log("inviteUser.1067: ---------- START INVITE CALL =", cmd, "  invite=",INFO.invite_key);
    var result = await getURL(url)
                .then(res0 => {
                    var res = res0.output;
                    console.log("inviteUser.1072:       INVITE RECEIVED   res=",res);
                    //if ((INFO.anon_mode === true) && (res !== undefined)) {
                    if ((INFO.invite_key !== null) && (res !== undefined)) {
                        console.log("inviteUser.1067:  --------------  INVITE ANON MODE SET TEMPUID COOKIE TO: ", res);
                        auth.setTempUID(res, INFO.invite_key);

                        INFO.temp_uid = res;       // used for detection
                        INFO.uid = res;            // used to call backend
                        process_user_invite("invite_user.1086");     // moved from index

                        //process_user_invite(null, "inviteUser.1081"); - NO!
                        //INFO.db_org = res.org;      // home org, get club branding from here
                    }
                    return res;
                })

    return result;
}


// quick fetch info to display splash page
//    - auto_play:  pass in drill=<drill_hash> and invite_key=<invite_key>
//    - invite:  pass in drill=<null> and invite_key=<invite_key>
//    - user:  pass in drill="_user_" and invite_key=<fb_uid>
//
export function FetchSplashInfo(drill_hash, invite_key, fb_uid, subdomain) {
    var cmd;
    if (invite_key != null) {
        cmd = "/user/splash/"+drill_hash+"/"+invite_key;        // fetch for invite or auto_play
    } else if (fb_uid !== null) {
        cmd = "/user/splash/_user_/"+fb_uid;      // fetch for the regular user
    } else {
        cmd = "/user/splash/"+subdomain+"/null";        // fetch custom domain splash
    }
    var url = NODE_API_SERVER+cmd;
    console.log("fetchSplash.1099: ---------- GET SPLASH INFO =", cmd, " drill_hash=",drill_hash,"  invite=",invite_key, " uid=",fb_uid, " subdomain=",subdomain);
    var result = getURL(url)
                .then(res0 => {
                    var res = res0.output;
                    console.log("fetchSplash.1103:       SPLASH INFO RECEIVED   res=",res);
                    if(res !== undefined) {
                        INFO.active_drill = res.drill;
                        INFO.splash = res.content;

                        /*  SWITCHED TO USING COOKIE
                        if(INFO.splash[0] !== undefined) {
                            INFO.splash_image = INFO.splash[0].org_key;
                            //INFO.splash_image = res.home_org_key;
                        }
                        */
                    } else {
                        INFO.splash_image = "axos";     // restore to default
                    }

                    //if ((INFO.anon_mode === true) && (res !== undefined)) {
                    //if ((INFO.invite_key !== null) && (res !== undefined)) {
                        //console.log("inviteUser.1067:  --------------  ANON MODE SET TEMPUID COOKIE TO: ", res);
                        //process_user_invite(null, "inviteUser.1081"); - NO!
                        //INFO.db_org = res.org;      // home org, get club branding from here
                    //}
                })

    return result;

}



// get db user info for this session
//     - get axos version number
//     - get tutorial read state
//     - get all related drills
//     - get today drill sequence
//     - get high scores (?)
//     - sets up sequence if none in db
//
//  NOTE: What happens to user with a viral open invite?
//
export function startUser(uid, invite_key) {
    var tz = new Date().getTimezoneOffset();        // in minutes, PST = 420
    var cmd = "/user/start/"+uid+"/"+tz+"/"+invite_key;
    var url = NODE_API_SERVER+cmd;
    console.log("startusr.1104: ==============  startUser() cmd=", cmd);
    var result = getURL(url)
                .then(res0 => {
                    var res = res0.output;
                    if ((res === undefined) || (res.org === undefined)) {
                        console.log("startusr.1117:         !!!! UNABLE TO RETRIEVE USER STATE!!!!", res);
                        return null
                    }
                    INFO.db_org = res.org;      // home org, get club branding from here
                    INFO.db_today = res.seqs;
                    INFO.db_contents = res.contents;
                    INFO.db_menus = res.menus;
                    INFO.db_sections = res.sections;
                    INFO.db_drills = res.drills;
                    INFO.db_motions = res.motions;
                    INFO.db_states = res.states;
                    INFO.db_leaders = res.leaders;
                    INFO.db_players = res.players;      // only has data if god
                    INFO.org_key = INFO.db_org.key;
                    console.log("startusr.975: USER STATE RECEIVED...... leaders=", INFO.db_leaders.length, "  org_key=",INFO.org_key, " db_drills=",INFO.db_drills);
                    return res;
                })
                .catch(err => {
                    console.log("startusr.1097: USER LOGIN ERROR! ", err );
                    return null;
                })

    return result;
}


// read https://storage.googleapis.com/app.axos.cc/version for server version
//
export async function getServerVersion() {
    //let usr = "https://storage.googleapis.com/app.axos.cc/version"
    var url = GOOGLE_BUCKET_SERVER + "/version";
    var result = getURL(url)
                .then(res0 => {
                    console.log("version.1768: ==============  got Axos Server Version  =", res0, " url=",url);
                    return res0
                })
                .catch(err => {
                    console.log("version.1754:  ERROR  no version file in bucket! ", err );
                    return null;
                })
    return result;
}




/////////////////////////////////////////////////////////////////////////
// ***** PRIMITIVE DATABASE OPS *****
//
// return browser public IP, for localhost testing return heroku IP
//    "ip": "69.181.219.69",
//    "city": "Saratoga",
//    "region_code": "CA",
//    "country": "US",
//    "latitude": 37.2539,
//    "longitude": -122.0638,
//    "org": "Comcast Cable Communications, LLC"
export function getIP() {
    var url = "https://ipapi.co/json/?key="+IPAPI_TOKEN;
    //var url = "http://www.geoplugin.net/json.gp";  // for non-https, use nothing in HEADER!

    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        //const heroku_url="https://cors-anywhere.herokuapp.com/"
        //url = heroku_url + url;
    }

    var result = getURL(url)
    .then(response => {
        if(response.status >= 400){
            //throw new Error("bad response from server")
            return {};
        }

        var ip_obj = {};
        var ip_raw = response;
        //console.log("GetIP: ip_raw=", ip_raw);
        ip_obj.ip = ip_raw.ip
        ip_obj.city = ip_raw.city
        ip_obj.region_code = ip_raw.region_code
        ip_obj.country = ip_raw.country
        ip_obj.latitude = ip_raw.latitude
        ip_obj.longitude = ip_raw.longitude
        ip_obj.org = ip_raw.org
        return ip_obj;
    })
    .then(data => {
        return data;
    })
    return(result);  // async result later, returns promise
}




// works with cors
//
export function getURL(url) {

    var result = fetch(url, {
        crossDomain: true,
        method: 'GET',
        mode: 'cors',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json, * /*'
        }
    })
    .then(response => {
           if(response.status >= 400){
                throw new Error("bad response from server")
           }
           var json = response.json();
          console.log("get_url.688: GET SUCCESSFUL resp=",response, " json=", json);
           if (json) {
              return json;     // axos return will have {output: <res>}
           } else {
              return response.text();
           }
    })
    .catch((err)=> {
        console.log("getURL.737: ----- getURL ERROR "+err.message+"   url="+url);
        return {"error": err.message}
    });

    return result;
}


// ref: https://developer.mozilla.org/en-US/docs/Web/API/Response
export function postURL(url, body) {

    if (((window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")) && (url.includes("axos.cc") === false)) {
        // CORS KLUDGE!
        //
        //url = cors_proxy_url + url;     // get around cors issue, may need visit *** http://cors-anywhere.herokuapp.com/corsdemo ****
    }

    // create firestore session record for later search and lookup
    //
    //console.log("dbsession.120:   body=", JSON.stringify(body));
    var result = fetch(url, {
        method: 'POST',
        mode: 'cors',        // set to no-cors works, but can't receive response
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    })
    .then(response => {
        var json = response.json();
        if(response.status >= 400){
            throw new Error("bad response from server")
        }
        //console.log("postURL.47: SUCCESSFUL ", json);
        return json;
    })
    .catch((err)=> {
        console.error("postURL.539: "+err.message);
        return {};
    });

    return result;
}


export async function getVimeoURL(url0) {
    var res = getVimeoURL1(url0, "GET");
    return res;
}

export async function putVimeoURL(url0) {
    var res = getVimeoURL1(url0, "PUT");
    return res;
}


async function getVimeoURL1(url0, type) {
    var url = url0;

    // src: https://github.com/tus/tus-js-client/issues/219  (WORKS)
    console.log("getVimeoURL.1415:  GET VIMEO ", url);
    const result = await fetch(url, {
        method: type,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        headers: {
            'Authorization': 'bearer '+VIMEO_BEARER_TOKEN,
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.vimeo.*+json;version=3.4',
            "Access-Control-Allow-Headers": "origin, access-control-allow-origin, access-control-allow-headers, content-type, accept",
            'Access-Control-Allow-Origin': "*"
        },
    })
    .then(response => {
           if(response.status >= 400){
                throw new Error("bad response from server")
            }
           //console.log("postVimeoURL.337: SUCCESSFUL ", response);
           return response.json();
    })
    .catch((err)=> {
        //console.error("getVimeoURL.1443: "+err.message);
        console.error("ERROR.1504:  LINK FAILED  "+err.message);
        console.error("ERROR.1504:              MIGHT NEED PROXY CLICK:  https://cors-anywhere.herokuapp.com/corsdemo");
    });

    return result;
}




export async function postVimeoURL(url, body) {

    // src: https://github.com/tus/tus-js-client/issues/219  (WORKS)
    console.log("postVimeoURL.798:  CREATE VIMEO HANDLE ", url);
    const result = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        headers: {
            'Authorization': 'bearer '+VIMEO_BEARER_TOKEN,
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.vimeo.*+json;version=3.4'
        },
        body: JSON.stringify(body)
    })
    .then(response => {
           var json = response.json();
           if(response.status >= 400){
                throw new Error("bad response from server")
            }
           //console.log("postVimeoURL.337: SUCCESSFUL ", json);
           return json;
    })
    .catch((err)=> {
        console.error("StoreHistory: "+err.message);
    });

    return result;
}


// WORKS
export function patchVimeoURL(url, body, offset) {

    console.log("vimeo_patch.356:   RUNNING PATCH       body=", JSON.stringify(body));
    var result = fetch(url, {
        method: "PATCH",
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        headers: {
            'Authorization': 'bearer '+VIMEO_BEARER_TOKEN,
            'Tus-Resumable': '1.0.0',
            'Upload-Offset': offset,
            'Content-Type':	'application/offset+octet-stream',
            'Accept': 'application/vnd.vimeo.*+json;version=3.4'
        },
        //body: JSON.stringify(body)
        //data: body
    })
    .then(response => {
           var json = response.json();
           if(response.status >= 400){
                throw new Error("bad response from server")
            }
           console.log("patchVimeoURL.337: SUCCESSFUL ", json);
           return json;
    })
    .catch((err)=> {
        console.error("patchVimeo.383: "+err.message);
    });

    return result;
}



// UTIL
// NOTE: XXCD turns email into URL-friendly string so we
export function makeUserKey(email, from) {
    if ((email !== undefined) && (email !== null) && (typeof(email) == "string")) {
        var key = email.replace("@",":").replace(/\./g,"_");
        return key;
    } else {
        console.log("makeukey.1342:  ERROR: BAD EMAIL  email=",email," from=",from);
    }
}


// tag the session with mode to help with index searching and analysis
//      - dev: "study@dev.test"   hardcode
//
export function sessionMode(email) {
    var mode = "normal";
    var bits = email.split("@");
    var bits0 = bits[0].split("_");
    var bits1 = bits[1].split(".");

    if (email === "anon:ldoit_com") { mode = "anon" };
    if (email.includes("geogatedproject") === true) { mode = "facebook" };
    if (bits1[0] === "dev") { mode = "dev" };
    if (bits1[0] === "student") { 
        mode = "student" 
        INFO.adhoc_mode = true;
    };

    console.log("sess_mode.1994:  # # # # #  Session Mode=",mode,"  email=",email);
    return mode;
}



export function makeUserHash(email) {
    var hash = "usr:" + makeUserKey(email, "makeUserHash.1375");
    return hash;
}




